import React, { useContext, useEffect, useState, useMemo } from "react";
import { MachineContext } from "../../context/MachineContext";
import { DepartmentContext } from "../../context/DepartmentContext";
import MachineCard from "./MachineCard";
import Pagination from "./Pagination";
import axios from "axios"; // API çağrısı için axios kullanabilirsiniz.

const Dashboard = () => {
  const { machines } = useContext(MachineContext);
  const { departments } = useContext(DepartmentContext);
  const [loading, setLoading] = useState(true);
  const [startTimes, setStartTimes] = useState([]); // Başlangıç saatlerini saklayacağız.
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastMachine = currentPage * itemsPerPage;
  const indexOfFirstMachine = indexOfLastMachine - itemsPerPage;
  const currentMachines = machines.slice(
    indexOfFirstMachine,
    indexOfLastMachine
  );

  const apiUrl = process.env.REACT_APP_MONGO_URL;

  // API'den başlangıç saatlerini çek
  useEffect(() => {
    const fetchStartTimes = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/machineStartTimes`); // API endpoint
        const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD formatında bugünün tarihi

        // Sisteminde bulunan makinelerin ID'lerini al
        const availableMachineIds = machines.map((machine) =>
          machine._id.toString()
        );

        // Sadece bugünün tarihine sahip olan verileri al
        const filteredTimes = response.data.filter((time) => {
          return (
            time.startTime &&
            time.startTime.startsWith(today) &&
            availableMachineIds.includes(time.machineId) // Sadece var olan makineleri getir
          );
        });

        setStartTimes(filteredTimes);
      } catch (error) {
        console.error("Başlangıç saatleri alınırken hata oluştu:", error);
      }
    };
    fetchStartTimes();
  }, [apiUrl, machines]);

  useEffect(() => {
    if (machines.length > 0) {
      setLoading(false);
    }
  }, [machines, startTimes]);

  // Memoized enriched machines
  const enrichedMachines = useMemo(() => {
    return currentMachines.map((machine) => {
      const department = departments.find((d) => d._id === machine.department);
      const startTimeData = startTimes.find(
        (time) => time.machineId === machine._id
      );
      const startTime = startTimeData ? startTimeData.startTime : null; // Eğer startTime yoksa null
      return { ...machine, department, startTime };
    });
  }, [currentMachines, departments, startTimes]);

  // Yüklenme durumu kontrolü
  if (loading) {
    return <div className="p-4">Loading...</div>;
  }

  return (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 p-4">
        {enrichedMachines.map((machine) => (
          <MachineCard
            key={machine._id}
            machine={machine}
            department={machine.department}
            startTime={machine.startTime} // Başlangıç saati gönderiliyor
          />
        ))}
      </div>
      <div className="flex justify-center">
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={machines.length}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default Dashboard;
